var path = '/modules/contacts/views/pages/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/list.tpl.html
// module id = 2083
// module chunks = 1